/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ar_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find the simplified aspect ratio of any width and height — like 16:9 — and resize to a new width while keeping the same ratio.`)
};

const es_ar_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encuentra la relación de aspecto simplificada de cualquier ancho y alto — como 16:9 — y redimensiona a un nuevo ancho manteniendo la misma relación.`)
};

const de_ar_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Findet das vereinfachte Seitenverhältnis einer beliebigen Breite und Höhe — wie 16:9 — und ändert die Größe auf eine neue Breite unter Beibehaltung desselben Verhältnisses.`)
};

const nl_ar_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vind de vereenvoudigde beeldverhouding van elke breedte en hoogte — zoals 16:9 — en pas de grootte aan naar een nieuwe breedte terwijl je dezelfde verhouding behoudt.`)
};

const fr_ar_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trouvez le rapport d'aspect simplifié de n'importe quelle largeur et hauteur — comme 16:9 — et redimensionnez à une nouvelle largeur en gardant le même rapport.`)
};

const it_ar_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trova il rapporto di aspetto semplificato di qualsiasi larghezza e altezza — come 16:9 — e ridimensiona a una nuova larghezza mantenendo lo stesso rapporto.`)
};

const pt_br2_ar_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encontre a taxa de aspecto simplificada de qualquer largura e altura — como 16:9 — e redimensione para uma nova largura mantendo a mesma taxa.`)
};

const pt_ar_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encontre a proporção de aspecto simplificada de qualquer largura e altura — como 16:9 — e redimensione para uma nova largura mantendo a mesma proporção.`)
};

const ja_ar_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任意の幅と高さの簡略化されたアスペクト比（16:9など）を見つけ、同じ比率を保ったまま新しい幅にリサイズします。`)
};

const zh_ar_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`找出任意宽度和高度的化简宽高比——例如16:9——并调整为新的宽度,同时保持相同的比例。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ar_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ar_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ar_intro", locale)
	if (locale === "en") return en_ar_intro(inputs)
	if (locale === "es") return es_ar_intro(inputs)
	if (locale === "de") return de_ar_intro(inputs)
	if (locale === "nl") return nl_ar_intro(inputs)
	if (locale === "fr") return fr_ar_intro(inputs)
	if (locale === "it") return it_ar_intro(inputs)
	if (locale === "pt-BR") return pt_br2_ar_intro(inputs)
	if (locale === "pt") return pt_ar_intro(inputs)
	if (locale === "ja") return ja_ar_intro(inputs)
	return zh_ar_intro(inputs)
};